import React, { useEffect, useState } from "react";
import { Box, Chip, Typography, Tooltip } from "@mui/material";
import { useParams } from "react-router-dom";

interface FilterTagsProps {
  title: string;
  maxVisible?: number;
  showAllInitially?: boolean;
  showTitle?: boolean;
  showTitleLine?: boolean;
  showCloseBtn?: boolean;
  combainesalldata?: string[];
  appliedFilters: string; // Accepts a comma-separated string
}

function FilterTags({
  title,
  maxVisible = 4,
  showAllInitially = false,
  showTitle = true,
  showTitleLine = true,
  showCloseBtn = true,
  appliedFilters = "",
  combainesalldata = [],
}: FilterTagsProps) {
  const { id } = useParams(); // Get cohort_id
  const [filters, setFilters] = useState<string[]>([]);
  const [showAll, setShowAll] = useState(showAllInitially);
  const { cohort_id } = useParams();
  // useEffect(() => {
  //   if (id || cohort_id && combainesalldata.length > 0) {
  //     setFilters(combainesalldata);
  //   } else if (appliedFilters) {
  //     const parsedFilters = appliedFilters
  //       .split(",")
  //       .map((item) => item.trim())
  //       .filter((item) => item !== "");
  //     setFilters(parsedFilters);
  //   }
  // }, [id, appliedFilters, cohort_id, combainesalldata]);


  useEffect(() => {
    if ((id || cohort_id) && combainesalldata.length > 0) {
      setFilters(combainesalldata);
    } else if (typeof appliedFilters === "string" && appliedFilters.trim() !== "") {
      const parsedFilters = appliedFilters
        .split(",")
        .map((item) => item.trim())
        .filter((item) => item !== "");
      setFilters(parsedFilters);
    } else if (Array.isArray(appliedFilters)) {
      // if appliedFilters sometimes comes as an array
      setFilters(appliedFilters);
    }
  }, [id, appliedFilters, cohort_id, combainesalldata]);



  const handleDelete = (indexToDelete: number) => {
    setFilters((prevFilters) =>
      prevFilters.filter((_, index) => index !== indexToDelete)
    );
  };
  console.log(cohort_id, "cohort_idcohort_idsssssssss")
  console.log(filters, "filtersssssssssssss")
  return (
    <><style>
      {`
      .filterData {
        width:100%;
        margin-bottom:10px
      }

      .filterData .MuiBox-root {
        display:inline-block;
      }
        .MuiTypography-root{width:auto;}
    `}
    </style><Box className="filterData"
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: "8px",
        padding: "10px 0 0",
        borderRadius: 2,
        "& .MuiBox-root": {
          display: "block"
        }
      }}
    >
        {showTitle && <Typography sx={{ width: "100%" }}>{title}</Typography>}

        {filters.length > 0 ? (
          filters.map((filter, index) => {
            if (!showAll && index >= maxVisible) return null;
            return (
              <Chip
                key={index}
                label={filter}
                onDelete={showCloseBtn ? () => handleDelete(index) : undefined}
                sx={{
                  backgroundColor: "#EAF5FE",
                  color: "#0F7CAD",
                  borderRadius: "5px",
                  fontSize: "14px",
                  height: "30px",
                  paddingRight: "10px",
                  "& .MuiChip-deleteIcon": {
                    color: "#007bff",
                    fontSize: "18px",
                    margin: "0",
                  },
                  "& .MuiChip-label": {
                    paddingRight: "8px",
                  },
                }}
                deleteIcon={showCloseBtn ? <span style={{ fontWeight: "bold" }}>×</span> : undefined} />
            );
          })
        ) : (
          <Box sx={{ paddingTop: "10px" }}>
            <p >No filters available</p>
          </Box>
        )}

        {filters.length > maxVisible && !showAll && (
          <Tooltip
            slotProps={{
              tooltip: {
                sx: {
                  backgroundColor: "transparent",
                  boxShadow: "none",
                  padding: 0,
                  color: "inherit",
                },
              },
            }}
            sx={{ background: "#fff", boxShadow: "none" }}
            title={<Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
              {filters.slice(maxVisible).map((filter, index) => (
                <Chip
                  key={index}
                  label={filter}
                  sx={{
                    backgroundColor: "#EAF5FE",
                    color: "#0F7CAD",
                    borderRadius: "5px",
                    fontSize: "14px",
                    height: "30px",
                  }} />
              ))}
            </Box>}
          >
            <Chip
              label={`more +${filters.length - maxVisible}`}
              sx={{
                backgroundColor: "#fff",
                color: "#C8172F",
                borderRadius: "5px",
                fontSize: "14px",
                height: "30px",
                cursor: "pointer",
                "&:hover": {
                  background: "#fff",
                },
              }} />
          </Tooltip>
        )}

        {showAll && filters.length > maxVisible && (
          <Chip
            label="Show Less"
            sx={{
              backgroundColor: "#fff",
              color: "#C8172F",
              borderRadius: "5px",
              fontSize: "14px",
              height: "30px",
              cursor: "pointer",
              "&:hover": {
                background: "#fff",
              },
            }} />
        )}
      </Box></>
  );
}

export default FilterTags;
